import * as React from 'react';
import { useEffect, useState, useCallback } from 'react';
import Modal from '../../components/modal';
import { Header, Body, Title, Right, Button, Icon, Content, H2, Accordion, View, Text, Input, Card } from 'native-base';
import { StyleSheet } from 'react-native';
import CalCalDataApi from '../../api/CalCalDataApi';
import { moneyInput as MoneyInput, textInput as TextInput, renderDateField as DateInput } from '../../forms/renderedComponents';

function renderHeader(item, expanded) {
	return (
		<View
			style={{
				flexDirection: 'row',
				padding: 10,
				justifyContent: 'space-between',
				alignItems: 'center',
				backgroundColor: '#e4ebef'
			}}>
			<Text>{item.datestring}</Text>
			<Text style={{ fontWeight: '600' }}> {item.title}</Text>
			<Text style={{ textAlign: 'right', alignSelf: 'flex-end' }}>{item.value}</Text>
			{expanded ? <Icon style={{ fontSize: 18 }} name="arrow-dropup" /> : <Icon style={{ fontSize: 18 }} name="arrow-dropdown" />}
		</View>
	);
}

export default function Stock({ show, close, jwt }) {
	const [rows, setRows] = useState([]);
	const [reload, setReload] = useState(0);
	const [entering, setEntering] = useState();
	const [value, setValue] = useState();
	const [note, setNote] = useState();
	const [date, setDate] = useState(new Date().toISOString().split('T')[0]);

	useEffect(() => {
		if (!show) return;
		//get previous
		CalCalDataApi.dataLoad('stock', jwt, res => {
			if (res.success) {
				setRows(res.rows);
			}
		});
	}, [reload, show]);

	const enterStock = () => {
		CalCalDataApi.dataInsert('stock', { value, note, date }, jwt, res => {
			if (res.success) {
				setReload(reload + 1);
				setEntering(false);
			}
		});
	};

	const deleteStock = id => {
		CalCalDataApi.dataDelete('stock/' + id, jwt, () => {
			setReload(reload + 1);
		});
	};

	const renderContent = useCallback(
		item => (
			<View padder>
				<Text note style={{ alignSelf: 'center' }}>
					{item.desc}
				</Text>
				<Text style={{ fontSize: 12, fontWeight: '600' }}>{item.dates}</Text>
				<View style={{ flexDirection: 'row', maxWidth: 250 }}>
					<Text style={{ flex: 3, fontSize: 12 }}> + All stock purchased</Text>

					<Text style={{ flex: 2, fontSize: 12, textAlign: 'right' }}>£ {item.purchased}</Text>
				</View>
				{!!item.sold && (
					<View style={{ flexDirection: 'row', maxWidth: 250 }}>
						<Text style={{ flex: 3, fontSize: 12 }}> - Stock retailed (estimated)</Text>

						<Text style={{ flex: 2, fontSize: 12, textAlign: 'right' }}>£ {item.sold}</Text>
					</View>
				)}
				{!item.opening && (
					<Button bordered danger style={{ alignSelf: 'flex-end' }} onPress={() => deleteStock(item.id)}>
						<Text>Delete</Text>
					</Button>
				)}
			</View>
		),
		[deleteStock]
	);

	return (
		<Modal
			isOpen={show}
			backButtonClose
			coverScreen
			swipeThreshold={100}
			//onClosingState={closing => this.onClosing(closing)}
			onClosed={() => close()}
			style={styles.modalStyle}
			//backdropOpacity={0.7}
			useNativeDriver>
			<Header style={styles.modalHeader}>
				<Body>
					<Title>Stock Valuation</Title>
				</Body>
				<Right>
					<Button transparent onPress={close}>
						<Icon name={'arrow-down'} />
					</Button>
				</Right>
			</Header>
			<Content padder style={{ backgroundColor: 'white', minHeight: 500 }}>
				<Accordion dataArray={rows} renderContent={renderContent} renderHeader={renderHeader} expanded={0} />
				{!entering && (
					<Button bordered style={{ margin: 10, alignSelf: 'center' }} onPress={() => setEntering(true)}>
						<Text>Enter current stock value</Text>
					</Button>
				)}
				{entering && (
					<Card>
						<MoneyInput label="Total stock value" meta={{}} input={{ value: value, onChange: setValue }} />
						<TextInput label="Note" meta={{}} input={{ value: note, onChange: setNote }} />
						<DateInput label="Date" meta={{}} input={{ value: date, onChange: setDate }} />
						<View padder style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
							<Button danger bordered onPress={() => setEntering(false)}>
								<Text>Cancel</Text>
							</Button>
							<Button bordered success onPress={enterStock}>
								<Text>Save</Text>
							</Button>
						</View>
					</Card>
				)}
			</Content>
		</Modal>
	);
}

const styles = StyleSheet.create({
	rowBack: {
		alignItems: 'center',
		backgroundColor: '#DDD',
		flex: 1,
		height: '100%',
		flexDirection: 'row',
		justifyContent: 'space-between'
		//paddingLeft: 15
	},
	hiddenBtn: {
		width: 55,
		height: '100%'
	},
	modalStyle: {
		borderRadius: 10,
		width: '90%',
		height: 'auto',
		maxHeight: '90%'
	},
	modalContainer: {
		//width: '100%',
		flex: 1,
		//justifyContent: 'center',
		backgroundColor: 'rgba(255,255,255,0)' //'#f8f8fc'
	},

	modalHeader: {
		height: 45,
		borderTopLeftRadius: 10,
		borderTopRightRadius: 10
	},

	bottomBtns: {
		backgroundColor: '#295670',
		flexDirection: 'row'
	}
});
